import React from 'react';

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Route render error:', error, info);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div className="surface-card rounded-lg border border-red-200 dark:border-red-900/50 bg-red-50 dark:bg-red-950/30 px-4 py-6 text-sm text-red-900 dark:text-red-100">
          <p className="font-semibold">This page failed to load.</p>
          <p className="mt-2 text-red-800 dark:text-red-200/90">{error.message || 'Unknown error'}</p>
          <button
            type="button"
            className="mt-4 rounded-md bg-red-600 px-3 py-1.5 text-white hover:bg-red-700 dark:bg-red-700 dark:hover:bg-red-600"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
